import { createApi } from "@reduxjs/toolkit/query/react";
import { tomService } from "./restService";

export const benchmarkingApi = createApi({
  reducerPath: "benchmarkingApi",
  baseQuery: tomService({
    baseUrl: `${process.env.REACT_APP_BASE_URL}`,
  }),
  tagTypes: ["LivePayReports"],

  endpoints: builder => ({
    /**
     * @Services - Live Pay Benchmarking
     */

    // Fetch all Live Pay reports for a company
    fetchLivePayBenchmarkingReport: builder.query({
      query: ({ company_id }) => ({
        url: `/company/${company_id}/benchmarking-report/live-pay/`,
        method: "GET",
      }),
      providesTags: ["LivePayReports"],
    }),

    // Create a new Live Pay report
    // createLivePayBenchmarkingReport: builder.mutation({
    //   query: ({ company_id, body }) => ({
    //     url: `/company/${company_id}/benchmarking-report/live-pay/`,
    //     method: "POST",
    //     body,
    //   }),
    //   invalidatesTags: ["LivePayReports"],
    // }),
    createLivePayBenchmarkingReport: builder.mutation({
      query: ({ company_id, body }) => ({
        url: `/company/${company_id}/benchmarking-report/live-pay/`,
        method: "POST",
        body,
      }),
      invalidatesTags: ["LivePayReports"],
    }),

    // Download Live Pay report
    downloadPayBenchmarkingReport: builder.query({
      query: ({ company_id, report_id }) => ({
        url: `/company/${company_id}/benchmarking-report-get/${report_id}/?download=true`,
        method: "GET",
      }),
      // invalidatesTags: ["LivePayReports"],
    }),
    // Download Live Pay report
    // benchmarkingReportByTitle: builder.query({
    //   query: ({ company_id, country_id, title, grade_id, job_function_id, job_sub_function_id }) => ({
    //     url: `/company/${company_id}/benchmarking-report-title/`,
    //     method: "POST",
    //     body: {
    //       country_id,
    //       title,
    //       grade_id,
    //       job_function_id,
    //       job_sub_function_id
    //     }
    //   }),
    // }),
    benchmarkingReportByTitle: builder.query({
  query: ({
    company_id,
    country_id,
    title,
    grade_id,
    job_function_id,
    job_sub_function_id,
    report_on, // ✅ now used in query string
  }) => ({
    url: `/company/${company_id}/benchmarking-report-title/?report_on=${report_on}`,
    method: "POST",
    body: {
      country_id,
      title,
      grade_id,
      job_function_id,
      job_sub_function_id,
    },
  }),
}),

  }),
});

export const {
  useFetchLivePayBenchmarkingReportQuery,
  useCreateLivePayBenchmarkingReportMutation,
  useDownloadPayBenchmarkingReportQuery,
  useLazyDownloadPayBenchmarkingReportQuery,
  useBenchmarkingReportByTitleQuery
} = benchmarkingApi;
